module.exports = __webpack_public_path__ + "img/front.76d37292.png";